/**
 * TanStack Query hooks for the deployment's capability sets.
 */

import { capabilitySetsApi } from "@/services/capabilitySetsApi"

import { useAllPages } from "./useAllPages"

const capabilitySetKeys = {
  all: ["capabilitySets"] as const,
  lists: () => [...capabilitySetKeys.all, "list"] as const,
}

/**
 * Fetch every capability set.
 */
export function useCapabilitySetsList() {
  const { items, isPending, error } = useAllPages(capabilitySetKeys.lists(), (nextToken) =>
    capabilitySetsApi.listCapabilitySets({ nextToken }),
  )
  return { sets: items, isPending, error }
}
